
import { Vue, Component, Prop } from 'vue-property-decorator';
import DeviceActions from '@/ui/components/devices/actions/DeviceActions.vue';
import ShowEventDotBase from '@/ui/components/devices/devices/base/ShowEventDotBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { IDevice } from '@/types/devices.types';

@Component({
  components: {
    DeviceActions,
    ShowEventDotBase,
    DeviceLayout,
    OutputFieldBase,
    LabelUnitWrapper,
  },
})
export default class TSGModulLadestation extends Vue {
  @Prop() deviceData!: IDevice;

  get langPath() {
    return `devices.${this.deviceData.data.type}`;
  }
}
